import React from 'react';

const CheckboxControl = ({ id, isChecked, onChange, label }) => {
  return (
    <label style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      fontStyle: 'italic', 
      color: '#526666', 
      margin: '2px' 
    }}>
      <span
        onClick={onChange}
        style={{
          display: 'inline-block',
          width: '16px',
          height: '16px',
          marginRight: '8px',
          border: '2px solid #526666',
          borderRadius: '4px',
          backgroundColor: isChecked ? '#526666' : 'transparent',
          cursor: 'pointer',
          position: 'relative',
          padding: '0 2px'
        }}
      >
        {isChecked && (
          <span
            style={{
              position: 'absolute',
              top: '-8px',
              left: '0px',
              fontSize: '24px',
              color: 'white',
              padding: '0 0 0 2px',
              margin: '0'
            }}
          >
            ✔
          </span>
        )}
      </span>
      {label}
    </label>
  );
};

export default CheckboxControl;
